import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { tinykeys } from 'tinykeys';
import { MediaType } from '../../models/chat';

export interface IImagesViewModalData {
	images: Array<string>;
	names?: Array<string>;
	usernames?: Array<string>;
	dates?: Array<string>;
	messageIds?: Array<number>;
	index: number;
	showMainButton?: boolean;
	showSecondaryButton?: boolean;
	showGoToMessageButton?: boolean;
	mainButtonText?: string;
	secondaryButtonText?: string;
	username?: string;
	date?: string;
	changedVersion?: boolean;
	types?: Array<MediaType>;
}

@Component({
	selector: 'app-images-view-modal',
	templateUrl: './images-view-modal.component.html',
	styleUrls: ['./images-view-modal.component.scss'],
	standalone: false
})
export class ImagesViewModalComponent implements OnInit, OnDestroy {

	isLoading: boolean = true;
	loadError: boolean = false;
	settings: IImagesViewModalData;
	tinyKeysSubscription: () => void;

	constructor(
		@Inject(MAT_DIALOG_DATA) private data: IImagesViewModalData,
		private dialogRef: MatDialogRef<ImagesViewModalComponent>
	) {
		this.tinyKeysSubscription = tinykeys(window, {
			'ArrowLeft': (event: KeyboardEvent): void => {
				event.preventDefault();
				if (this.settings.images?.length > 1) this.previousImage();
			},
			'ArrowRight': (event: KeyboardEvent): void => {
				event.preventDefault();
				if (this.settings.images?.length > 1) this.nextImage();
			}
		});
	}

	ngOnInit(): void {
		this.settings = this.data;
	}

	nextImage(): void {
		this.goToIndex(this.settings.index === this.settings.images.length - 1 ? 0 : this.settings.index + 1);
	}

	onClose(result: string = ''): void {
		this.dialogRef.close(result);
	}

	showInChat(): void {
		const messageId: number | undefined = this.settings.messageIds?.[this.settings.index];
		if (!messageId) return;
		this.dialogRef.close({ action: 'show_in_chat', messageId });
	}

	previousImage(): void {
		this.goToIndex(this.settings.index === 0 ? this.settings.images.length - 1 : this.settings.index - 1);
	}

	onMediaLoad(): void {
		this.isLoading = false;
	}

	onMediaError(): void {
		this.isLoading = false;
		this.loadError = true;
	}

	private goToIndex(index: number): void {
		const currentUrl: string = this.settings.images[this.settings.index];
		const nextUrl: string = this.settings.images[index];
		this.settings.index = index;
		this.loadError = false;
		this.isLoading = currentUrl !== nextUrl;
	}

	isVideo(url: string, index: number): boolean {
		if (this.settings.types && this.settings.types[index]) {
			return this.settings.types[index] === 'video';
		}
		const videoExtensions: Array<string> = ['.mp4', '.webm', '.ogg', '.mov'];
		return videoExtensions.some((ext: string): boolean => url.toLowerCase().includes(ext)) || url.startsWith('blob:') && url.includes(
			'#video');
	}

	ngOnDestroy(): void {
		if (this.tinyKeysSubscription) this.tinyKeysSubscription();
	}
}
